<template>
  <div>
    <div v-if="subjects.NCS && subjects.NCS.length" >
      <folder-label label="NCS 교과" :open="true">
        <ul class="list-unstyled" style="font-size:14px">
          <li class="ml-3" v-for="(s) in subjects.NCS" :key="s._id">
            <!-- lecture들 전개 및 링크 -->
            <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
            <ul class="list-unstyled">
              <li class="ml-3" v-for="(l) in s.lectures" :key="l._id"
                :class="isActive(l.name)" @click="onNcsLecture(s.name, l.name, l.code)">
                {{l.name}}
              </li>
            </ul>
          </li>
        </ul>
      </folder-label>
      <hr>
    </div>
    <div v-if="subjects.NONNCS && subjects.NONNCS.length" >
      <folder-label label="비 NCS 교과"  :open="true">
        <ul class="list-unstyled" style="font-size:14px">
          <li class="ml-3" v-for="(s) in subjects.NONNCS.filter(s=>s.lectures.length>0)" :key="s._id"
            :class="isActive(s.name)" @click="onNonncsSubject(s.name)">
            <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
          </li>
        </ul>
      </folder-label>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import FolderLabel from '../common/FolderLabel.vue';
export default {
  name: 'SubjectCategory',
  components: { FolderLabel },
  data: () => ({
  }),
  computed: {
    ...mapState('training', ['subjects']),
    active () {
      return this.$route.query.lecture || this.$route.query.subject
    }
  },
  methods: {
    isActive (name) {
      return this.active === name ? 'list active bolder red-text' : 'pointer'
    },
    onNcsLecture (subject, name, code) {
      if (this.active !== name) {
        this.$emit('select-ncs-lecture', subject, name, code)
      }
    },
    onNonncsSubject (subject) {
      if (this.active !== subject) {
        this.$emit('select-nonncs-subject', subject)
      }
    }
  },
  watch: {
  }
}
</script>
